import useTitleBreakdownViewModel from './TitleBreakdownViewModel'
import { TITLE_BREAKDOWN_STATUSES, MAIN_TAB, TAB_TYPE_DEED } from '@/constants'
import { Link } from 'react-router-dom'
import CircleSpinner from '@/components/shared/CircleSpinner'
import { FaGears } from 'react-icons/fa6'
import { ConveyanceTable } from '../Chaining/ConveyanceTable/ConveyanceTable'

export const TitleBreakdown = () => {
    
    const vm = useTitleBreakdownViewModel()
    
    const chainingBreadcrumb = () =>
        <div className="text-sm breadcrumbs ml-4 pt-0">
            <ul>
                <li><Link to="/collections">Home</Link></li>
                <li><Link to="/runsheets">Runsheets</Link></li>
                <li><Link to={`/runsheet/${vm.runsheet?.id}?activeTab=${vm.activeTab}`}>{vm.runsheet?.name ?? ''}
                    {vm.activeTab !== MAIN_TAB ? ` (${vm.currentTab.name})` : ''}</Link></li>
                <li>Title Chain</li>
            </ul>
        </div>
    
    if (TITLE_BREAKDOWN_STATUSES.PROCESSING === vm.titleBreakdown?.status) return ( 
        <div className="flex flex-col w-full">
            {chainingBreadcrumb()}
            <div className="card bg-base-100 w-96 shadow-sm mx-auto mt-10">
                <figure>
                    <FaGears className="text-5xl" />
                </figure>
                <div className="card-body">
                    <h2 className="card-title">Title Chain Processing</h2>
                    <p>The title chain is processing. It should be ready soon.</p>
                    <div className="mx-auto"><CircleSpinner /></div>
                </div>
            </div>
        </div>
    )
    
    if (TITLE_BREAKDOWN_STATUSES.MANUAL_PROCESSING === vm.titleBreakdown?.status) return (
        <div className="flex flex-col">
            {chainingBreadcrumb()}
            <div className="flex flex-col items-center">
                <div className="text-2xl my-5 mt-10">The Title Chain is loading. It should be ready soon.</div>
                <CircleSpinner />
            </div>
        </div>
    )
    
    if (TITLE_BREAKDOWN_STATUSES.MANUAL_FAILED === vm.titleBreakdown?.status) return (
        <div className="flex flex-col">
            {chainingBreadcrumb()}
            <div className="flex flex-col items-center">
                <div className="text-2xl mt-10">
                    We're sorry for the inconvenience, but the Title Chain failed to complete.
                </div>
                <div className="text-2xl my-5 mt-2">
                    Please retry and if the problem persists let us know and we'll be happy to help.
                </div>
                <div className="text-2xl my-5">
                    <button className="btn btn-primary" onClick={vm.retryChaining}>Retry</button>
                </div>
            </div>
        </div>
    )
    
    return (
        
        <div className="flex flex-col">
            
            <ConveyanceTable
                chain={vm.titleBreakdown}
                setChain={vm.setTitleBreakdown}
                conveyanceType={TAB_TYPE_DEED}
                runsheetDocs={vm.runsheetDocs}
                activeTab={vm.activeTab}
                hasMissingData={vm.hasMissingData}
                hasRecentFailure={vm.hasRecentFailure}
                setHasRecentFailure={vm.setHasRecentFailure}
                handleChain={vm.handleTitleChain}
                exportChain={vm.exportTitleChain}
                exportLoading={vm.exportLoading}
                chainingBreadcrumb={chainingBreadcrumb}/>
        
        </div>
        
    )
    
}
